export enum PartOfDay {
  am = 'am',
  pm = 'pm',
}
